import classes from "./creditsExpireDashboard.module.css";

const CreditsExpireDashboard = props => {
  const { expiryDate, expiringCredits, postJob } = props;
  return (
    <div className={classes.expireContainer}>
      <div className={classes.heading}>
        {expiringCredits}
        <img src="/hire/coin-icon.svg" alt="coin" height={13} width={13} />{" "}
        Credits
        <span>
          will expire <br /> on {expiryDate}
        </span>
      </div>
      <div onClick={postJob} className={classes.postJob}>
        Post a job
      </div>
    </div>
  );
};

export default CreditsExpireDashboard;
